import { PROVIDERS, WEEKPLAN } from "../../config"

interface CalenderProps {
	dayContent?: any
	className?: any
}

const Calender: React.FC<CalenderProps> = ({ dayContent, className }) => {
	if (!dayContent) {
		const d = new Date()
		dayContent = WEEKPLAN.filter(weekday => weekday.getDay === d.getDay())[0]
	}

	return (
		<div className={"max-w-[495px] mx-auto " + className}>
			<img src={"images/card/" + dayContent.provider + ".png"} className="w-full calenderShadow  my-[8%]" alt="" />
		</div>
	)
}
export default Calender
